export default __webpack_public_path__ + "9561c357f3c557a360ab0e65b485714e.png";